module.exports = require("core-js-pure/features/object/values");